var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 29.3566C16.0445 29.2118 16.2436 29.1273 16.4548 29.1273H35.6089C35.959 29.1273 36.134 29.5497 35.8865 29.7972L32.1028 33.5809C31.958 33.7258 31.7588 33.8102 31.5476 33.8102H12.3935C12.0435 33.8102 11.8685 33.3878 12.1159 33.1404L15.8996 29.3566Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 15.2293C16.0505 15.0845 16.2496 15 16.4548 15H35.6089C35.959 15 36.134 15.4224 35.8865 15.6699L32.1028 19.4536C31.958 19.5984 31.7588 19.6829 31.5476 19.6829H12.3935C12.0435 19.6829 11.8685 19.2605 12.1159 19.0131L15.8996 15.2293Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1028 22.2476C31.958 22.1028 31.7588 22.0183 31.5476 22.0183H12.3935C12.0435 22.0183 11.8685 22.4407 12.1159 22.6882L15.8996 26.4719C16.0445 26.6167 16.2436 26.7012 16.4548 26.7012H35.6089C35.959 26.7012 36.134 26.2788 35.8865 26.0314L32.1028 22.2476Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.7792,
    y1: 12.7398,
    x2: 20.523,
    y2: 38.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 27.9828,
    y1: 9.71352,
    x2: 14.7267,
    y2: 35.1044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 30.8626,
    y1: 11.2169,
    x2: 17.6064,
    y2: 36.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.4a0546175f1f76022c388d384c53e386.svg";
export { ForwardRef as ReactComponent };